/* eslint-disable import/prefer-default-export */

// A column the truncated cone form does not show: not enabled, not mapped, or set to
// 'hidden' in the mapping (as in the barrel form). Submit validation skips these
// fields, since the operator cannot fill them.
export const isColumnHidden = (columns, fieldName) => {
  const fieldConfig = columns?.[fieldName];
  return !fieldConfig?.enabled || !fieldConfig?.mapping?.csvName
    || fieldConfig.displayStyle === 'hidden';
};
